import { createSlice } from "@reduxjs/toolkit";

const storesSlice = createSlice({
    name: 'selectedMarkets',
    initialState: {
        selectedStores: [],
        isAll : false,
    },
    reducers: {
        setSelectedStores: (state, action) => {
            state.selectedStores = action.payload && Array.isArray(action.payload) ?action.payload:[];
        },
        setIsAllStoresSelected: (state, action) => {
            state.isAll = action.payload;
        },
        clearSelectedStores: (state) => {
            state.selectedStores = [];
        }
    }
});

export const { setSelectedStores,clearSelectedStores,setIsAllStoresSelected } = storesSlice.actions;
export default storesSlice.reducer;